module.exports = __webpack_public_path__ + "static/media/icoCheck.cf4f293d.svg";